// extracted by mini-css-extract-plugin
module.exports = {"credentialsContainer":"EditUserAccountForm_credentialsContainer__1GwHW"};